var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.969 24.227V24.238V24.248V24.254V24.268C33.9285 24.3864 33.8618 24.494 33.774 24.583L27.174 31.253C27.0985 31.3329 27.0076 31.3965 26.9068 31.4401C26.8059 31.4836 26.6973 31.5062 26.5874 31.5063C26.4776 31.5065 26.3688 31.4843 26.2679 31.4411C26.1669 31.3979 26.0757 31.3346 26 31.255C25.8614 31.1131 25.7776 30.9265 25.7635 30.7286C25.7494 30.5307 25.8059 30.3342 25.923 30.174L26 30.082L31.2 24.83H16.818C16.6091 24.8274 16.4088 24.7461 16.2571 24.6025C16.1054 24.4588 16.0134 24.2633 15.9994 24.0548C15.9854 23.8463 16.0504 23.6402 16.1816 23.4776C16.3127 23.3149 16.5003 23.2076 16.707 23.177L16.818 23.17H31.2L26 17.919C25.8462 17.7622 25.76 17.5513 25.76 17.3315C25.76 17.1118 25.8462 16.9009 26 16.744C26.1371 16.6032 26.3209 16.517 26.5169 16.5018C26.7129 16.4865 26.9077 16.5431 27.065 16.661L27.157 16.741L33.757 23.41C33.9129 23.5668 34.0003 23.779 34 24C34 24.0768 33.9896 24.1531 33.969 24.227Z",
    fill: "#0D0F27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/go.ea7ed1f1638dba805c1f1cf9c8290a32.svg";
export { ForwardRef as ReactComponent };